export default "__VITE_ASSET__Ccc4r_La__"